// get the last git commit by ident-mechanism of gitattributes

// don't change the format string in the next line - it's automatically filled in by git!
export const release = 'product-data-daemon-q4-UNDEFINED';